<template>
  <Body class="lp">
    <!-- STEP 1 -->
    <div class="columns" style="padding: 20px; max-width: 500px;" v-if="isOne">
      <div class="column">
        <h2 style="padding: 16px; font-size: larger; font-weight: 600;">無料ユーザー登録（求職者さま向け）</h2>
        <hr>
        <b-field style="font-size:13px;" horizontal label="お名前">
            <b-input v-model="inputs.username"
              minlength="2"
              maxlength="50"
              icon="account"></b-input>
        </b-field>
        <b-field style="font-size:13px;" horizontal :label="$t('CreateBody.email')">
            <b-input v-model="inputs.email"
              type="email"
              icon="email"
              maxlength="254"
              expanded>
            </b-input>
        </b-field>
        <b-field style="font-size:13px;" horizontal :label="$t('CreateBody.password')">
            <b-input v-model="inputs.password"
              type="password"
              icon="lock"
              minlength="8"
              password-reveal></b-input>
        </b-field>
        <b-field horizontal
          style="font-size:13px;"
          :label="$t('CreateBody.repassword')"
          :message="checks.repassword"
          :custom-class="dangerText"
          :type="dangerType">
            <b-input v-model="repassword"
              type="password"
              icon="lock"
              minlength="8"
              password-reveal></b-input>
        </b-field>
        <b-field>
          <a href="/terms" target="_blank" rel="noopener" class="button is-primary">
            利用規約を読む
          </a>
        </b-field>
        <b-field>
          <b-checkbox v-model="check"
          type="is-primary">
              {{ $t('CreateBody.accept_rule') }}
          </b-checkbox>
        </b-field>
        <hr>
        <button class="button is-large is-primary" style="width: 200px; border-radius: 100px;" @click="createAccount(inputs)" :disabled="disabled">
          無料登録
        </button>
      </div>
    </div>
    <!-- STEP 3 -->
    <div class="columns" style="padding:20px; border-radius: 5px; flex-wrap: wrap !important;" v-if="isThree">
      <div style="display: flex; flex-wrap: wrap !important; max-width: 100%; min-height: 450px;">
        <div style="font-size: 16px; text-align: center; width: 100vw;">
          <p>ご登録完了いたしました！メールを送付いたしましたので、</p>
          <p>メール内容をご確認いただきまして、ログインを行なってください。</p>
        </div>
        <div style="text-align: center; width: 100vw;">
          <img style="height:auto; width: 200px; margin-left: 50px;" src="../../assets/template/mail.png">
        </div>
        <div style="width: 100vw; padding: 50px;">
          <a class="button is-large is-primary" style="width: 250px; border-radius: 100px;" @click="close">ページを閉じる</a>
        </div>
      </div>
    </div>
    <!-- STEP 4 -->
    <div class="columns" style="padding:20px; border-radius: 5px; flex-wrap: wrap !important;" v-if="isFour">
      <div style="width: 100vw;"><p style="white-space: normal;">エラーが発生いたしました。</p></div>
      <div style="display: flex; flex-wrap: wrap !important; max-width: 100%; min-height: 450px;">
        <div style="font-size: 14px; text-align: center; width: 100vw;">
          <p>大変申し訳ございません。ご登録の内容に不備がないかご確認の上、</p>
          <p>ページを再読み込みして、再登録のほど、よろしくお願いいたします。</p>
          <p>もしくは<router-link to="/inquiry">こちら</router-link>からお問い合わせをお願いいたします。</p>
        </div>
        <div style="width: 100vw; padding: 50px;">
          <a class="button is-large is-primary" style="width: 300px; border-radius: 100px;" @click="reload">ページを再読み込み</a>
        </div>
      </div>
    </div>
    <div class="lp-bottom-text">
      <p><a class="campany-link" href="https://www.robottte.com/" target="blank">運用会社はこちら</a></p>
      <p>Copyright(c) 2021 robottte Co., Ltd. All Rights Reserved.</p>
    </div>
  </Body>
</template>

<script>
import Body from '@/components/layouts/Body'
import ModalTerm from '@/components/ui/ModalTerm'
import ModalSelectBilling from '@/components/ui/ModalSelectBilling'
import { mapState, mapActions } from 'vuex'
export default {
  name: 'CreateBody',
  componentName: 'CreateBody',
  components: {
    Body,
    ModalTerm,
    ModalSelectBilling
  },
  data () {
    return {
      isOne: true,
      isTwo: false,
      isThree: false,
      isFour: false,
      check: false,
      showModal: false,
      uploadedImage: '',
      filename: 'no file',
      repassword: '',
      inputs: {
        request_status: 1,
        username: '',
        email: '',
        password: '',
        plan: 0,
        is_client: false,
        is_user: true,
        scenario: localStorage.getItem('_init_scenario') ? JSON.parse(localStorage.getItem('_init_scenario')) : []
      },
      checks: {
        repassword: ''
      },
      dangerType: '',
      dangerText: ''
    }
  },
  computed: {
    // state
    ...mapState('signup', ['activationCompleted', 'activationError', 'registrationLoading', 'registrationCompleted', 'registrationError']),
    disabled () {
      console.debug('*** Start *** disabled')
      return this.inputs.username === '' ||
             this.inputs.email === '' || this.inputs.password === '' ||
             this.repassword === '' || !this.check ||
             this.inputs.username.length < 2 ||
             this.inputs.password.length < 8 || this.repassword.length < 8 ||
             this.inputs.password !== this.repassword || this.checkEmailAddress(this.inputs.email)
    }
  },
  watch: {
    repassword: {
      handler: function (val, oldVal) {
        if (this.inputs.password === this.repassword) {
          this.checks.repassword = ''
          this.dangerType = ''
          this.dangerText = ''
        } else if (this.repassword !== '') {
          this.checks.repassword = this.$t('CreateBody.checkRepassword')
          this.dangerType = 'is-danger'
          this.dangerText = 'has-text-danger'
        }
      },
      deep: true
    },
    registrationCompleted () {
      this.isThree = true
      this.isOne = false
      this.isTwo = false
      this.isFour = false
      // クエリパラメータを持っていないので、リクエストしてもキーエラーになる
      // リクエスト先のAuthProfileDataはここでしか使っていない
      // this.createProfileData({
      //   'sessionid': this.$route.query.sessionid,
      //   'apply_url': this.$route.query.url,
      //   'email'    : this.inputs.email
      // })
    },
    registrationError () {
      this.isFour = true
      this.isOne = false
      this.isTwo = false
      this.isThree = false
    }
  },
  methods: {
    ...mapActions('signup', ['createAccount', 'createProfileData', 'activateAccount', 'clearRegistrationStatus', 'clearActivationStatus']),
    snackbar () {
      console.debug('*** Start *** snackbar')
      this.$buefy.snackbar.open({
        message: '登録エラーです。',
        position: 'is-top'
      })
      this.clearRegistrationStatus()
      console.debug('*** End *** snackbar')
    },
    checkEmailAddress (str) {
      console.debug('*** Start *** checkEmailAddress')
      return str.match(/.+@.+/) == null
    },
    selectSP () {
      console.debug('*** Start *** selectSP')
      this.$buefy.toast.open({
        message: 'ローンチパートナースペシャルプランは別途申請が必要です。お問い合わせにてご連絡ください。',
        type: 'is-primary'
      })
      console.debug('*** End *** selectSP')
    },
    modalSelectBilling () {
      console.debug('*** Start *** modalSelectBilling')
      this.$store.dispatch('setting/modalSelectBilling')
      console.debug('*** End *** modalSelectBilling')
    },
    reload () {
      console.debug('*** Start *** reload')
      location.reload()
      console.debug('*** End *** reload')
    },
    close () {
      // 閉じたらログイン画面に遷移する
      this.$router.push('/login')
    }
  }
}
</script>

<style scoped>
.lp {
  overflow-y: scroll;
  scroll-behavior: smooth;
  -ms-overflow-style: none;
  overflow: -moz-scrollbars-none;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.circle {
  width: 40px;
  height: 40px;
  padding: 8.5px;
  font-weight: 700;
  font-size: 14px;
  border: solid 2px #292950;
  border-radius: 50%;
  background: white;
}
.line {
  margin-top: 20px;
  flex-grow: 1;
  border-top: solid 3px #292950;
}
.is-one {
  background: #00CBCB;
}
.is-two {
  background: #00CBCB;
}
.is-three {
  background: #00CBCB;
}
.title {
  font-size: 14px;
  font-weight: 700;
}
.parent-plan {
  max-width: 900px;
  height: auto;
  display: flex;
  justify-content: space-around;
  background: #f5f5f5;
  padding: 20px;
  border-radius: 5px;
}
.std-plan {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background: #fff;
  width: 475px;
  /* height: 550px; */
  border-radius: 5px;
  border: solid thin #ccc;
  padding: 20px;
  font-size: 10px;
  text-align: left;
}
.pro-plan {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background: #fff;
  width: 475px;
  /* height: 550px; */
  border-radius: 5px;
  border: solid thin #ccc;
  padding: 20px;
  font-size: 10px;
  text-align: left;
  margin-left: 20px;
}
.sp-plan {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background: #fff;
  width: 475px;
  /* height: 550px; */
  border-radius: 5px;
  border: solid thin #ccc;
  padding: 20px;
  font-size: 9.5px;
  text-align: left;
  margin-left: 20px;
}
.lp-bottom-text {
  width: 100%;
  background: #1B2C61;
  color: white;
  padding-bottom: 6px;
  padding-top: 2px;
}
.to-top {
  position: fixed;
  bottom: 2%;
  right: 1%;
  height: 64px;
  width: 64px;
  background: #1B2C61;
  box-shadow: 2px 2px 5px rgba(0,0,0,0.3);
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.to-top > img {
  height: 50px;
  width: 50px;
}
.campany-link {
  color: #ffffff;
  border-bottom: solid thin #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/views/CreateUser/CreateBody.vue